// extracted by mini-css-extract-plugin
export default {"ambient_toggle_container":"AmbientToggle_ambient_toggle_container__nXlpP","active_btn":"AmbientToggle_active_btn__jdnI6","non_active_btn":"AmbientToggle_non_active_btn__DXfwZ"};